import { Component, EventEmitter, OnInit } from '@angular/core';
import { DwCardBaseComponent, DwComponent, DwComponentType, DwDataFormatService, DwFormatTypes, DwMetaDataListCardConfigData, DwQueryMetaData, DwRoutingService } from '@devwareapps/devware-cap';
import { AppMetaData, AppMetaDataItemNames, AssignmentByStudentQueryEntity, AssignmentCourseLessonEntity, AssignmentEntity, AssignmentLessonWithProgressForStudentQueryEntity, LessonTypeAllItems, QuizTypeAllItems, RoAssignmentStudentCourseLessonProgressEntity } from '../../../../../meta-data/app-meta-data.service';
import { CourseNavigationService } from '../../../../courses/services/course-navigation.service';
import { LessonReferenceInfo } from '../../../../courses/models/lesson-reference-info.model';
import { DateTimeUtilService } from '../../../../shared/util/date-time-util.service';


@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Assignment Card - New',
  key: 'assignmentCardNew',
  componentType: DwComponentType.card,
  //configComponent: DwCardDefaultConfigComponent,
  isGlobal: true,
  parentItemName: AppMetaDataItemNames.AssignmentCourseLesson,
  configData: {
    contentItemDefinitions: [{
      display: 'Main',
      contentItemKey: 'main'
    }]
  }
})  
@Component({
  selector: 'app-assignment-card-new',
  templateUrl: './assignment-card-new.component.html',
  styleUrls: ['./assignment-card-new.component.scss']
})
export class AssignmentCardNewComponent implements DwCardBaseComponent<any, AssignmentLessonWithProgressForStudentQueryEntity> {
  cardConfig?: any; 
  data?: AssignmentByStudentQueryEntity;
  resolvedContext?: any;
  cardClick: EventEmitter<any> = new EventEmitter<any>();
  dueDateTime: string;
  percentCompleteText: string;
  lessonCount: number;
  dueClass:string;
  dueInMinutes: number;
  currentDate: string;
  currentDateFormatted: string;

  lessonProgress: RoAssignmentStudentCourseLessonProgressEntity[] = [];
  //lessonProgress: { lessonDisplay:string, lesson: AssignmentCourseLessonEntity; progress: RoAssignmentStudentCourseLessonProgressEntity; }[] = [];
  preventClick: boolean;
  dueClass2: string;
  
  constructor(private dwDataFormatService: DwDataFormatService,
    private dwRoutingService: DwRoutingService,
    private courseNavigationService: CourseNavigationService,
    private dateTimeUtilService: DateTimeUtilService
  ) { }
  queryMetaData?: DwQueryMetaData;

  maxLessonsToShow = 3;

  setupCard() {
    this.dueDateTime = this.dwDataFormatService.formatValue(this.data?.DueDateTime, { formatType: DwFormatTypes.datetime, useGmtDateTime: true});
   
    this.lessonCount = this.data?.AssignmentIdRoAssignmentStudentCourseLessonProgress?.length || 1;

    let currentDate = this.dateTimeUtilService.getCurrentDateTime();
    this.currentDateFormatted = this.dwDataFormatService.formatValue(currentDate, { formatType: DwFormatTypes.datetime, useGmtDateTime: true});

    this.dueInMinutes = this.dateTimeUtilService.calcDurationMinutes(currentDate, this.data?.DueDateTime, null, null,null,true);
 
    if (this.dueInMinutes<0 && !this.data?.CompletedDateTime) {
      this.dueClass = 'dw-red';
      this.dueClass2 = 'assignment-past-due';
    }
    if (this.dueInMinutes>=0 && this.dueInMinutes < 60 * 24) {
      this.dueClass = 'dw-orange';
      this.dueClass2 = 'assignment-due-soon';
    }

    for(let progress of this.data.AssignmentIdRoAssignmentStudentCourseLessonProgress) {
      //const progress = this.data.AssignmentIdRoAssignmentStudentCourseLessonProgress.find((progress) => progress.CourseLessonId == lesson.CourseLessonId);

      if (!progress?.LessonComplete || this.data.AssignmentStudentPercentComplete==100) {
        this.lessonProgress.push(progress);
      }

      if (this.lessonProgress.length >= this.maxLessonsToShow) {
        break;
      }

      //progress.LessonName
    
      // this.lessonProgress.push({
      //   lessonDisplay: lesson.CourseLessonIdDisplay,
      //   lesson: lesson,
      //   progress: progress
      // })
    }

    this.data.AssignmentCourseLesson

  }

  quizLessonTypeId = LessonTypeAllItems.Quiz
  click() {
    if (this.preventClick) {
      return;
    }

    const url = `/my-assignments/view/${this.data?.AssignmentStudentAssignmentStudentId}`;

    this.dwRoutingService.navigateToUrl(url, null);

    // const lessonReference : LessonReferenceInfo = {
    //   courseId: this.data.AssignmentCourseId,
    //   moduleId: this.data.CourseModuleCourseModuleId,
    //   lessonId: this.data.CourseLessonId
    // }
    // this.courseNavigationService.navigateToLesson(lessonReference);

  }

  clickProgress(lesson: RoAssignmentStudentCourseLessonProgressEntity) {
    this.courseNavigationService.navigateToLesson({
      courseId: lesson.CourseId,
      moduleId: lesson.CourseModuleId,
      lessonId: lesson.CourseLessonId
    });

    this.preventClick = true;
  }

}
